import { Tooltip_detail as Tooltip } from "../../utility/common/helpers/Tooltip";
import Img from "../../../icons/ErrorIcon.svg";
import { Form } from "react-bootstrap";
import { useState } from "react";
import { SearchSelect } from "../../utility/forms/inputs/search-select";
import { isAlphanumericAllSpecialCharacters } from "../../../functions/validations";
import PropTypes from "prop-types";


export const handleSetError = (setError, name, error, error1, element) => {
  let key = element.Actual_Value != undefined;
  if (key)
    setError((prevState) => ({
      ...prevState,
      [name]: [
        { Actual_Value: [error1] },
        {
          Range_Qualified: [error[name][1].Range_Qualified[0]],
        },
      ],
    }));
  else
    setError((prevState) => ({
      ...prevState,
      [name]: [
        {
          Actual_Value: [error[name][0].Actual_Value[0]],
        },
        { Range_Qualified: [error1] },
      ],
    }));
};
export const WPQProcessInput1 = ({
  wpq_process,
  Index,
  maxlength,
  readOnly,
  status,
  status1,
  handleActualValueChange,
  name,
  handleRangeQualifiedChange,
  message,
  message1,
  ColumnHeader,

  setError,
  error,
  allowlistfunction,
}) => {
  WPQProcessInput1.propTypes = {
    wpq_process: PropTypes.array,
    Index: PropTypes.number,
    handleActualValueChange: PropTypes.func,
    name: PropTypes.string,
    message: PropTypes.string,
    message1: PropTypes.string,
    maxlength: PropTypes.number,
    ColumnHeader: PropTypes.string,
    readOnly: PropTypes.bool,
    status1: PropTypes.bool,
    status: PropTypes.bool,

    handleRangeQualifiedChange: PropTypes.func,
    error: PropTypes.array,
    setError: PropTypes.func,
  };

  let elementtype;
  return (
    <tr
      className={
        status || status1 ? "border WpqInput-md error" : "border WpqInput-md"
      }
    >
      <th className={"text-start thead-color"}>
        <div>
          {ColumnHeader}
          {(status || status1) && (
            <Tooltip content={message || message1}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>

      {wpq_process?.[name]?.map((element, id) => {
        elementtype =
          element.Actual_Value != undefined
            ? element.Actual_Value
            : element.Range_Qualified;

        return (
          <td key={`td-${name}-${id}`}>
            <div>
              <div>
                {elementtype?.map((value, valueIndex) => {
                  return (
                    <input
                      style={{
                        marginRight: "10px",
                        marginLeft: "14px",
                      }}
                      key={`${name}-${id}-${valueIndex}`}
                      type="text"
                      name={name}
                      readOnly={readOnly}
                      value={value}
                      maxLength={maxlength}
                      onChange={(e) =>
                        handlechange(
                          element,
                          { handleActualValueChange, handleRangeQualifiedChange },
                          { Index, name, id, valueIndex },
                          e.target.value
                        )
                      }
                      onInput={(e) => {
                        let error1 = allowlistfunction ? allowlistfunction(e.target.value) : isAlphanumericAllSpecialCharacters(e.target.value);
                        handleSetError(
                          setError,
                          name,
                          error,
                          error1,
                          element
                        );
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </td>
        );
      })}
    </tr>
  );
};

export const WPQProcessInput1Row3 = ({
  wpq_process,
  Index,
  maxlength,
  disabled,
  readOnly,
  status,
  status1,
  handleActualValueChange,
  handleOtherChange,
  name,
  handleRangeQualifiedChange,
  message,
  message1,
  ColumnHeader,
  SfaActive,
  valueField,
  customstyles,
  setError,
  error,
  combinedLabel,
  combinedOptions
}) => {
  WPQProcessInput1Row3.propTypes = {
    wpq_process: PropTypes.array,
    Index: PropTypes.number,
    handleActualValueChange: PropTypes.func,
    handleOtherChange: PropTypes.func,
    SfaActive: PropTypes.array,
    name: PropTypes.string,
    message: PropTypes.string,
    valueField: PropTypes.string,
    customstyles: PropTypes.string,
    disabled: PropTypes.string,
    message1: PropTypes.string,
    maxlength: PropTypes.number,
    ColumnHeader: PropTypes.string,
    readOnly: PropTypes.bool,
    status1: PropTypes.bool,
    status: PropTypes.bool,

    handleRangeQualifiedChange: PropTypes.func,
    error: PropTypes.array,
    setError: PropTypes.func,
    combinedLabel: PropTypes.string,
    combinedOptions: PropTypes.bool
  };

  let elementtype;

  return (
    <tr
      className={
        status || status1 ? "border error" : "border"
      }
    >
      <th className={"text-start thead-color"}>
        <div>
          {ColumnHeader}
          {(status || status1) && (
            <Tooltip content={message || message1}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>
      {/* Below code is working */}
      {wpq_process?.[name]?.map((element, id) => {
        elementtype =
          element.Actual_Value != undefined
            ? element.Actual_Value
            : element.Range_Qualified;

        return (
          <>
            {elementtype?.map((value, valueIndex) => {
              return (
                <td className="WpqInput-md" key={`input-${id}-${valueIndex}`}>
                  <div key={`div-${id}-${valueIndex}`}>
                    <input
                      key={`${name}-${id}-${valueIndex}`}
                      style={{
                        marginRight: "10px",
                        marginLeft: "10px",
                      }}
                      type="text"
                      maxLength={maxlength}
                      readOnly={readOnly}
                      name={name}
                      value={value}
                      onChange={(e) => {
                        handlechange(
                          element,
                          { handleActualValueChange, handleRangeQualifiedChange },
                          { Index, name, id, valueIndex },
                          e.target.value
                        );
                        let error1 = isAlphanumericAllSpecialCharacters(e.target.value);
                        handleSetError(setError, name, error, error1, element);
                      }}
                    />
                  </div>
                </td>
              );
            })}
            {
              element.Other?.map((value, valueIndex) => {
                return (
                  <td className="WPQSelect" style={{ paddingLeft: "2%" }} key={`search-${value}`}>
                    <SearchSelect
                      className="inspdrop"
                      data={SfaActive}
                      valueField={valueField}
                      disabled={disabled}
                      placeholder=""
                      value={value}
                      labelField={valueField}
                      combinedLabel={combinedLabel}
                      combinedOptions={combinedOptions}
                      onChange={(e) => {
                        handleOtherChange(Index, name, id, valueIndex, e.value);
                      }}
                    />
                  </td>
                );
              })}
          </>
        );
      })}
    </tr>
  );
};

export const handlechange = (element, handlers, params, value) => {
  let key = element.Actual_Value != undefined;
  if (key)
    handlers.handleActualValueChange(params.Index, params.name, params.id, params.valueIndex, value);
  else
    handlers.handleRangeQualifiedChange(params.Index, params.name, params.id, params.valueIndex, value);
};

export const WPQProcessSelect = ({
  wpq_process,
  Index,
  disabled,
  status,
  status1,
  handleActualValueChange,
  name,
  handleRangeQualifiedChange,
  message,
  message1,
  ColumnHeader,
  array,
}) => {
  WPQProcessSelect.propTypes = {
    wpq_process: PropTypes.array,
    Index: PropTypes.number,
    handleActualValueChange: PropTypes.func,
    name: PropTypes.string,
    message: PropTypes.string,
    message1: PropTypes.string,
    ColumnHeader: PropTypes.string,
    disabled: PropTypes.bool,
    status1: PropTypes.bool,
    status: PropTypes.bool,
    handleRangeQualifiedChange: PropTypes.func,
    array: PropTypes.array,
  };

  let elementtype;
  return (
    <tr
      className={
        status || status1 ? "border WpsInput-md error" : "border WpsInput-md"
      }
    >
      <th className={"text-start thead-color"}>
        <div>
          {ColumnHeader}
          {(status || status1) && (
            <Tooltip content={message || message1}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>

      {/* Below code is working */}
      {wpq_process?.[name]?.map((element, id) => {
        elementtype =
          element.Actual_Value != undefined
            ? element.Actual_Value
            : element.Range_Qualified;
        return (
          <td key={element?.id || `td-${name}-${id}`} style={{ textAlign: "center" }}>
            <div>
              <div>
                {elementtype?.map((value, valueIndex) => {
                  return (
                    <div className="T-input w-20" key={`div-${value}-${element?.id || id}`}>
                      <select
                        key={`${name}-${id}-${valueIndex}`}
                        style={{
                          width: "120px",
                          margin: "0 auto",
                        }}
                        name={name}
                        disabled={disabled}
                        value={value}
                        onChange={(e) => {
                          handlechange(
                            element,
                            { handleActualValueChange, handleRangeQualifiedChange },
                            { Index, name, id, valueIndex },
                            e.target.value
                          );
                        }}
                      >
                        {array &&
                          array.map((e) => {
                            return (
                              <option key={e.value} value={e.value}>
                                {e.name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  );
                })}
              </div>
            </div>
          </td>
        );
      })}
    </tr>
  );
};

export const WPQProcessSelectData = ({
  wpq_process,
  Index,
  status,
  disabled,
  handleActualValueChange,
  name,
  handleRangeQualifiedChange,
  message,
  ColumnHeader,
  SfaActive,
  valueField,
  customstyles,
  customstyles2,
}) => {
  WPQProcessSelectData.propTypes = {
    wpq_process: PropTypes.array,
    Index: PropTypes.number,
    handleActualValueChange: PropTypes.func,
    name: PropTypes.string,
    message: PropTypes.string,
    customstyles: PropTypes.string,
    customstyles2: PropTypes.string,
    SfaActive: PropTypes.array,
    ColumnHeader: PropTypes.string,
    disabled: PropTypes.bool,
    status: PropTypes.bool,
    handleRangeQualifiedChange: PropTypes.func,
    valueField: PropTypes.string,
  };
  let elementtype;

  return (
    <tr className={status ? "border error" : "border"}>
      <th className={"text-start thead-color"}>
        <div>
          {ColumnHeader}
          {status && (
            <Tooltip content={message}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>

      {wpq_process?.[name]?.map((element, id) => {
        elementtype =
          element.Actual_Value != undefined
            ? element.Actual_Value
            : element.Range_Qualified;
        let custstyle =
          element.Actual_Value != undefined ? customstyles : customstyles2;

        return (
          <td key={element?.id || `td-${name}-${id}`}>
            <div>
              <div className="selectstyle">
                {elementtype?.map((value, valueIndex) => {
                  return (
                    <SearchSelect
                      key={`${name}-${id}-${valueIndex}`}
                      data={SfaActive}
                      disabled={disabled}
                      readOnly={disabled}
                      name={name}
                      valueField={valueField}
                      labelField={valueField}
                      stylegreen={custstyle}
                      value={value}
                      placeholder=""
                      onChange={(e) => {
                        value = e.value;
                        handlechange(
                          element,
                          { handleActualValueChange, handleRangeQualifiedChange },
                          { Index, name, id, valueIndex },
                          value
                        );
                      }}
                    ></SearchSelect>
                  );
                })}
              </div>
            </div>
          </td>
        );
      })}
    </tr>
  );
};

export const WPQProcessCheckBox = ({
  wpq_process,
  Index,
  status,
  disabled,
  readOnly,
  name,
  handleRangeQualifiedChangeCheckBox,
  message,
  ColumnHeader,
}) => {
  WPQProcessCheckBox.propTypes = {
    wpq_process: PropTypes.array,
    Index: PropTypes.number,
    handleRangeQualifiedChangeCheckBox: PropTypes.func,
    name: PropTypes.string,
    message: PropTypes.string,
    ColumnHeader: PropTypes.string,
    disabled: PropTypes.bool,
    status: PropTypes.bool,
    readOnly: PropTypes.bool,
  };
  return (
    <tr className={status ? "border WpsInput-md error" : "border WpsInput-md"}>
      <th className={"text-start thead-color"}>
        <div>
          {ColumnHeader}
          {status && (
            <Tooltip content={message}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>

      {/* Below code is working */}
      <td></td>
      <td>
        <div key={Index}>
          {wpq_process &&
            wpq_process[name] &&
            wpq_process[name].map((element, id) => {
              return (
                <div key={`process-${name}-${element?.id || id}`}>
                  {element.Range_Qualified &&
                    element.Range_Qualified.map((value, valueIndex) => {
                      return (
                        <>
                          <input
                            className="checkboxcolor"
                            style={{
                              marginRight: "8px",
                              marginLeft: "8px",
                              width: "15px",
                              height: "15px",
                            }}
                            disabled={disabled}
                            readOnly={readOnly}
                            key={`checkbox-${name}-${element?.id || id}-${value[3] || valueIndex}`}
                            type="checkbox"
                            name={name}
                            value={value}
                            checked={value[2] === "Checked"}
                            onChange={(e) => {
                              handleRangeQualifiedChangeCheckBox(
                                Index,
                                name,
                                id,
                                valueIndex,
                                e.target.value
                              );
                            }}
                          />
                          <Form.Label className="checkbox_label">{value[3]}</Form.Label>
                        </>
                      );
                    })}
                </div>
              );
            })}
        </div>
      </td>
    </tr>
  );
};

export const WPQProcessInputAndCheckbox = ({
  wpq_process,
  Index,
  disabled,
  status,
  readOnly,
  status1,
  handleRangeQualifiedChange2,
  name,
  checkedbox,
  handleRangeQualifiedChangeCheckBox2,
  message,
  message1,
  ColumnHeader,
  setError,
  onInput,
  onInput1,
  maxlength,
  handleActualValueChange,
  handleRangeQualifiedChange,
}) => {

  WPQProcessInputAndCheckbox.propTypes = {
    wpq_process: PropTypes.array,
    Index: PropTypes.number,
    handleRangeQualifiedChangeCheckBox2: PropTypes.func,
    handleRangeQualifiedChange2: PropTypes.func,
    checkedbox: PropTypes.bool,
    name: PropTypes.string,
    message: PropTypes.string,
    message1: PropTypes.string,
    setError: PropTypes.func,
    onInput: PropTypes.func,
    onInput1: PropTypes.func,
    maxlength: PropTypes.number,
    handleActualValueChange: PropTypes.func,
    handleRangeQualifiedChange: PropTypes.func,
    ColumnHeader: PropTypes.string,
    disabled: PropTypes.bool,
    status: PropTypes.bool,
    status1: PropTypes.bool,
    readOnly: PropTypes.bool,
  };
  let elementRange;
  if (wpq_process) {
    elementRange = wpq_process[name][1].Range_Qualified[0].Range_Qualified1;
    console.log("unchecked", elementRange);
  }
  return (
    <tr className={status || status1 ? "border WpsInput-md error" : "border WpsInput-md"}>
      <th className={"text-start thead-color"}>
        <div>
          {ColumnHeader}
          {(status || status1) && (
            <Tooltip content={message || message1}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>

      {/* Below code is working */}
      <td className="WpqInput-md">
        <div key={Index}>
          {wpq_process?.[name]?.map((element, id) => {
            return (
              <div key={`process-input-${id}`}>
                {element.Actual_Value?.map((value, valueIndex) => {
                  return (
                    <input
                      key={`${name}-${id}-${valueIndex}`}
                      style={{
                        marginRight: "10px",
                        marginLeft: "14px",
                      }}
                      type="text"
                      name={name}
                      readOnly={readOnly}
                      value={value}
                      maxLength={maxlength}
                      onChange={(e) =>
                        handlechange(
                          element,
                          { handleActualValueChange, handleRangeQualifiedChange: () => { } },
                          { Index, name, id, valueIndex },
                          e.target.value
                        )
                      }
                      onInput={onInput}
                    />
                  );
                })}
              </div>
            );
          })}
        </div>
      </td>
      <td>
        <div>
          {elementRange?.map((value, valueIndex) => {
            let checked =
              wpq_process[name][1].Range_Qualified[2]
                .Range_Qualified2[0][2] === "Checked";
            console.log("checked", checked, value[0], value);
            let val = checked ? "9.999.00" : value;
            let placeholder = checked ? "" : "Enter Value";
            return (
              <div key={`range-div-${name}-${valueIndex}`} className="input_checkbox">
                <div>
                  <input
                    key={`range-input-${name}-${valueIndex}`}
                    style={{
                      marginRight: "8px",
                      marginLeft: "60px",
                      border: "none",
                    }}
                    type="text"
                    maxLength={10}
                    name={name}
                    value={val}
                    readOnly={checked}
                    placeholder={placeholder}
                    onChange={(e) => {
                      handleRangeQualifiedChange2(Index, name, 1, 0, 0, checkedbox, e.target.value);
                    }}
                    onInput={onInput1}
                  />
                </div>
                <div>
                  <Form.Label className="OR_label">OR</Form.Label>
                </div>
                <div>
                  <input
                    className="checkboxcolor"
                    style={{
                      marginRight: "8px",
                      marginLeft: "50px",
                      marginTop: "5px",
                      width: "15px",
                      height: "15px",
                    }}
                    type="checkbox"
                    disabled={disabled}
                    name={name}
                    value={val}
                    checked={checked}
                    onChange={(e) => {
                      handleRangeQualifiedChangeCheckBox2(
                        Index,
                        name,
                        1,
                        e.target.checked
                      );
                      setError((prevState) => ({
                        ...prevState,
                        [name]: [
                          { Actual_Value: [""] },
                          {
                            Range_Qualified: [
                              {
                                Range_Qualified1: [""],
                              },
                            ],
                          },
                        ],
                      }));
                    }}
                  />
                  <Form.Label className="checkbox_label">No Limit</Form.Label>
                </div>
              </div>
            );
          })}
        </div>
      </td>
    </tr>
  );
};